import { Box, Container, CssBaseline, Stack, Toolbar, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import BpsPrivacyPolicyContent from './BpsPrivacyPolicyContent';

export const BPS_PRIVACY_POLICY_PATH = '/bps-privacy-policy';

const BpsPrivacyPolicyPage = () => {
  return (
    <>
      <CssBaseline />
      <Container
        component="main"
        maxWidth="md"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 'calc(100vh - 50px)',
          py: 3,
          px: { xs: 2, sm: 3 },
          boxSizing: 'border-box',
        }}
      >
        <Toolbar />
        <Stack spacing={2} sx={{ flex: 1, minHeight: 0 }}>
          <Typography variant="h5" component="h1" align="center">
            <Trans i18nKey="menu.bps-privacy-policy">Blueprint Studio Privacy Policy</Trans>
          </Typography>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflowY: 'auto',
              userSelect: 'text',
              color: 'text.primary',
              lineHeight: 1.6,
              pb: 4,
            }}
            data-testid="bps-privacy-policy-content"
          >
            <BpsPrivacyPolicyContent />
          </Box>
        </Stack>
      </Container>
    </>
  );
};

export default BpsPrivacyPolicyPage;
